import { useEffect, useState } from 'react';
import { navItems, siteInfo } from '@/mocks/home';

export default function SiteHeader() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const handleNavClick = () => setOpen(false);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-300 ${
        scrolled || open
          ? 'bg-background-50/95 backdrop-blur border-b border-background-200'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-8 h-16 md:h-[72px] flex items-center justify-between">
        <a
          href="#top"
          className="flex items-center gap-2.5 group"
          aria-label={`${siteInfo.name} 首页`}
        >
          <span
            className={`w-9 h-9 rounded-lg flex items-center justify-center transition-colors ${
              scrolled || open ? 'bg-primary-500 text-background-50' : 'bg-background-50/90 text-primary-700'
            }`}
          >
            <i className="ri-plant-line text-lg" />
          </span>
          <span className="flex flex-col leading-none">
            <strong
              className={`font-heading text-lg md:text-xl transition-colors ${
                scrolled || open ? 'text-foreground-950' : 'text-background-50'
              }`}
            >
              {siteInfo.name}
            </strong>
            <span
              className={`hidden sm:block text-[11px] mt-0.5 transition-colors ${
                scrolled || open ? 'text-foreground-500' : 'text-background-100/80'
              }`}
            >
              围观心理学 · 冷知识 · 段子表情包
            </span>
          </span>
        </a>

        <nav className="hidden lg:flex items-center gap-1" aria-label="主导航">
          {navItems.map((item) => (
            <a
              key={item.id}
              href={`#${item.id}`}
              className={`px-3 py-2 text-sm rounded-md whitespace-nowrap transition-colors ${
                scrolled
                  ? 'text-foreground-700 hover:text-primary-700 hover:bg-primary-50'
                  : 'text-background-100 hover:text-background-50 hover:bg-background-50/15'
              }`}
            >
              {item.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <a
            href="#subscribe"
            className="hidden md:inline-flex items-center gap-1.5 px-4 py-2 rounded-md text-sm whitespace-nowrap bg-accent-500 text-background-50 hover:bg-accent-600 transition-colors"
          >
            <i className="ri-notification-3-line" />
            订阅瓜田日报
          </a>
          <button
            type="button"
            onClick={() => setOpen((v) => !v)}
            aria-label={open ? '关闭菜单' : '打开菜单'}
            aria-expanded={open}
            className={`lg:hidden w-10 h-10 flex items-center justify-center rounded-md transition-colors ${
              scrolled || open ? 'text-foreground-900 hover:bg-background-200' : 'text-background-50 hover:bg-background-50/15'
            }`}
          >
            <i className={open ? 'ri-close-line text-2xl' : 'ri-menu-3-line text-2xl'} />
          </button>
        </div>
      </div>

      {open && (
        <div className="lg:hidden border-t border-background-200 bg-background-50 px-4 py-3">
          <nav className="grid grid-cols-2 gap-2" aria-label="移动端导航">
            {navItems.map((item) => (
              <a
                key={item.id}
                href={`#${item.id}`}
                onClick={handleNavClick}
                className="px-3 py-2.5 rounded-md text-sm text-foreground-700 bg-background-100 hover:bg-primary-50 hover:text-primary-700 transition-colors"
              >
                {item.label}
              </a>
            ))}
          </nav>
          <a
            href="#subscribe"
            onClick={handleNavClick}
            className="mt-3 flex items-center justify-center gap-1.5 px-4 py-2.5 rounded-md text-sm bg-accent-500 text-background-50 hover:bg-accent-600 transition-colors"
          >
            <i className="ri-notification-3-line" />
            订阅瓜田日报
          </a>
        </div>
      )}
    </header>
  );
}